import React, { useEffect, useState } from 'react'

import { IoClose, IoChevronBack, IoChevronForward, IoSave, IoNotifications } from "react-icons/io5";


import { GoLinkExternal } from "react-icons/go";
import { toast, ToastContainer } from 'react-toastify';

import "../CSS/components.css"
import "../CSS/global.css"
import axios from 'axios';

import { API } from "./constant"
import Home from './Home';
import Login from './Login';
import { MdClose } from 'react-icons/md';
// icons start 
import { IoEye, IoEyeOff } from "react-icons/io5";
import { IoMdCopy } from "react-icons/io";

const AllSoftware = () => {
    const [showAddSoftware, setShowAddSoftware] = useState(false);
    const [softwareList, setSoftwareList] = useState([]);
    const [editingSoftware, setEditingSoftware] = useState(null);
    const [showSoftwareDetails, setShowSoftwareDetails] = useState(false);
    const [selectedSoftware, setSelectedSoftware] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const [notifications, setNotifications] = useState([]);
    const [showNotifications, setShowNotifications] = useState(false);

    const [userRole, setUserRole] = useState("")
    const [userName, setuserName] = useState("")
    const [userLocation, setUserLocation] = useState("")

    const [visibleRowId, setVisibleRowId] = useState(null);

console.log(userName)

    const maskValue = (value) => {
        if (!value) return "N/A";
        if (value.length <= 3) return "***";
        return value.slice(0, 2) + "*".repeat(value.length - 2);
    };
    const fetchSoftware = async () => {
        try {
            const response = await axios.get(`${API}/all-software`)
            //  console.log(response)
            setSoftwareList(response.data);
        } catch (error) {
            if (error.response?.status === 401 || error.response?.data?.message === "Invalid Token") {
                window.location.href = "/";
            } else {
                console.error("Error fetching software details:", error);
            }
        }
    };
    // const fetchSoftware = async () => {
    //     try {
    //         const response = await axios.get(`${API}/all-software`)
    //     //  console.log(response)
    //         setSoftwareList(response.data);
    //     } catch (error) {
    //         console.error("Error fetching software details:", error);
    //     }
    // };
    const fetchNotifications = async () => {
        try {
            const response = await axios.get(`${API}/all-software/send-notifications`);
            // console.log(response.data)
            setNotifications(response.data);
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    }

    const fetchUserRole = async () => {
        try {
            const response = await axios.get(`${API}/register/get-user-role`)
            // console.log(response.data.data)
            setUserRole(response.data.data)
        } catch (error) {
            console.log("Error fetching user role", error)
        }
    }


    const fetchUserName = async () => {
        try {
            const response = await axios.get(`${API}/register/get-user-name`)
            // console.log(response.data.data)
            setuserName(response.data.data)
        } catch (error) {
            console.log("Error fetching user role", error)
        }
    }


    const fetchUserLocation = async () => {
        try {
            const response = await axios.get(`${API}/register/get-user-location`)
            // console.log(response.data.data)
            setUserLocation(response.data.data)
        } catch (error) {
            console.log("Error fetching user role", error)
        }
    }

    useEffect(() => {
        fetchSoftware();
        fetchNotifications();
        fetchUserRole()
        fetchUserName()
        fetchUserLocation()
    }, []);
    // console.log(editingSoftware);

    const handleSubmitSoftware = async (data) => {
        try {
            if (editingSoftware) {
                // console.log(data)
                await axios.put(`${API}/all-software/${editingSoftware._id}`, data);
                toast.success("Software updated successfully!");
            } else {
                await axios.post(`${API}/all-software`, data);
                toast.success("Software added successfully!");
            }
            fetchSoftware();
            setShowAddSoftware(false);
            fetchNotifications(); // Refresh notifications as well
            setEditingSoftware(null);
        } catch (error) {
            if (error.response) {
                toast.warning(error.response.data.message || "Something went wrong");
            } else if (error.request) {
                toast.warning("Server not responding. Please try again.");
            } else {
                toast.warning("Unexpected error occurred.");
            }
        }
    };

    const handleEdit = (software) => {
        setEditingSoftware(software);
        setShowAddSoftware(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this software?")) {
            try {
                await axios.delete(`${API}/all-software/${id}`);
                toast.success("Software deleted successfully!");
                fetchSoftware();
                fetchNotifications();
            } catch (error) {
                console.error("Error deleting software:", error);
                toast.error("Failed to delete software.");
            }
        }
    };

    const handleOpenDetails = (software) => {
        setSelectedSoftware(software);
        setShowSoftwareDetails(true);
    };

    const handleCloseDetails = () => {
        setSelectedSoftware(null);
        setShowSoftwareDetails(false);
    };

    const handleCloseModal = () => {
        setShowAddSoftware(false);
        setEditingSoftware(null);
    }




    const formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString();
    }

    const filteredSoftware = softwareList.filter((software) => {
        const query = searchTerm.trim().toLowerCase();
        if (!query) return true;

        const name = (software.softwareName || "").toLowerCase();
        const category = (software.category || "").toLowerCase();
        const ownerName = (software.ownerName || "").toLowerCase();
        return name.includes(query) || category.includes(query) || ownerName.includes(query);
    });

    return (
        <div>

            <ToastContainer autoClose={1000} />
            <div className='card_button_container'>
                    <div>
                        <p className='text-[12px]'>Welcome {userName}</p>
                    </div>
                <div className='button_search DFJCBAIC marginB10'>
                    <div>
                        <h2 className="xl:text-base 2xl:text-xl font-bold">Consolidated Software Inventory</h2>
                    </div>
                    <div className='DFJCCAIC gap10'>

                        <div style={{ position: 'relative' }}>
                            <IoNotifications
                                size={24}
                                className="cursor-pointer"
                                onClick={() => setShowNotifications(!showNotifications)}
                                style={{ color: notifications.length > 0 ? "red" : "gray" }}
                            />
                            {notifications.length > 0 && (
                                <span className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full text-xs w-4 h-4 flex items-center justify-center">
                                    {notifications.length}
                                </span>
                            )}

                            {showNotifications && (
                                <div className="absolute right-0 mt-2 w-80 bg-white border rounded shadow-lg z-50">

                                    <div className="p-2 border-b font-bold flex justify-between items-center">
                                        <span>Expiry Alerts</span>
                                        <span><MdClose onClick={() => setShowNotifications(!showNotifications)} /></span>
                                    </div>


                                    <div className="max-h-60 overflow-y-auto">
                                        {notifications.length === 0 ? (
                                            <div className="p-2 text-sm text-gray-500">No upcoming expiries.</div>
                                        ) : (
                                            notifications.map(notif => (
                                                <div key={notif._id} className="p-2 border-b text-sm">
                                                    <strong>{notif.softwareName}</strong> expires on {formatDate(notif.licenceExpiryDate)}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div>
                            {
                                userRole === "SUPER ADMIN" || userRole === "ADMIN" ? (
                                    <button onClick={() => setShowAddSoftware(true)} className='add_button'>Add New Software</button>
                                ) : null
                            }
                        </div>
                        <div>
                            <input
                                className='search_box'
                                type="search"
                                placeholder='Search software...'
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <hr />

                <div className='table_container width100'>
                    <table className="mac_table">
                        <thead>
                            {
                                userRole === "SUPER ADMIN" ? (
                                    <tr>
                                        <th>Name</th>
                                        <th>Category</th>
                                        <th>School Location</th>
                                        <th>Licence Type</th>
                                        <th>Status</th>
                                        <th>Vendor</th>
                                        <th>Owner</th>
                                        <th>Actions</th>
                                    </tr>

                                ) : (
                                    <tr>
                                        <th>Name</th>
                                        <th>Category</th>
                                        {/* <th>School Location</th> */}
                                        <th>LoginId</th>
                                        <th>Password</th>
                                        {/* <th>Vendor</th> */}
                                        <th>Owner</th>
                                        <th>Actions</th>

                                    </tr>
                                )
                            }
                        </thead>

                        <tbody>
                            {filteredSoftware.map((software) => (

                                // userRole && userRole === "SUPER ADMIN"  ? (
                                //     <tr
                                //         key={software._id}
                                //         onClick={() => handleOpenDetails(software)}
                                //         style={{ cursor: "pointer" }}
                                //     >
                                //         <td>{software.softwareName}</td>
                                //         <td>{software.category}</td>
                                //         <td>{(Array.isArray(software.schoolLocation) ? software.schoolLocation.join(', ') : software.schoolLocation) || "N/A"}</td>
                                //         <td>{software.licenceType}</td>
                                //         <td>
                                //             <span className={`status_pill ${software.status.toLowerCase()}`}>
                                //                 {software.status}
                                //             </span>
                                //         </td>
                                //         <td>{software.vendorName || "N/A"}</td>
                                //         <td>{software.ownerName || "N/A"}</td>
                                //         <td>
                                //             <div className="flex gap-2">

                                //                 <a
                                //                     href={software.url}
                                //                     target="_blank"
                                //                     rel="noopener noreferrer"
                                //                     onClick={(e) => e.stopPropagation()}
                                //                 >
                                //                     <GoLinkExternal />
                                //                 </a>
                                //                 <button
                                //                     onClick={(e) => {
                                //                         e.stopPropagation();
                                //                         handleEdit(software);
                                //                     }}
                                //                     className="edit_btn"
                                //                 >
                                //                     Edit
                                //                 </button>
                                //                 <button
                                //                     onClick={(e) => {
                                //                         e.stopPropagation();
                                //                         handleDelete(software._id);
                                //                     }}
                                //                     className="delete_btn text-red-500 font-bold"
                                //                 >
                                //                     Delete
                                //                 </button>
                                //             </div>
                                //         </td>
                                //     </tr>

                                // ) : (

                                //     <tr
                                //         key={software._id}
                                //         onClick={() => handleOpenDetails(software)}
                                //         style={{ cursor: "pointer" }}
                                //     >
                                //         <td>{software.softwareName}</td>
                                //         <td>{software.category}</td>
                                //         <td>{(Array.isArray(software.schoolLocation) ? software.schoolLocation.join(', ') : software.schoolLocation) || "N/A"}</td>
                                //         <td>
                                //             {visibleRowId === software._id
                                //                 ? software.portalId
                                //                 : maskValue(software.portalId)}
                                //         </td>

                                //         <td>
                                //             {visibleRowId === software._id
                                //                 ? software.portalPassword
                                //                 : maskValue(software.portalPassword)}
                                //         </td>
                                //         <td>{software.ownerName}</td>
                                //         <td>
                                //             <div className="flex gap-2">
                                //                 {/* <button
                                //                     onClick={(e) => {
                                //                         e.stopPropagation();
                                //                         handleEdit(software);
                                //                     }}
                                //                     className="edit_btn"
                                //                 >
                                //                     Edit
                                //                 </button> */}
                                //                 {/* <button
                                //                     onClick={(e) => {
                                //                         e.stopPropagation();
                                //                         handleDelete(software._id);
                                //                     }}
                                //                     className="delete_btn text-red-500 font-bold"
                                //                 >
                                //                     Delete
                                //                 </button> */}

                                //                 <a
                                //                     href={software.url}
                                //                     target="_blank"
                                //                     rel="noopener noreferrer"
                                //                     onClick={(e) => e.stopPropagation()}
                                //                 >
                                //                     <GoLinkExternal />
                                //                 </a>

                                //                 <span
                                //                     onClick={(e) => {
                                //                         e.stopPropagation();
                                //                         setVisibleRowId(
                                //                             visibleRowId === software._id ? null : software._id
                                //                         );
                                //                     }}
                                //                     style={{ cursor: "pointer" }}
                                //                 >
                                //                     {
                                //                         visibleRowId === software._id
                                //                             ? <IoEyeOff />
                                //                             : <IoEye />
                                //                     }
                                //                 </span>

                                //                 <button
                                //                     onClick={(e) => {
                                //                         e.stopPropagation();
                                //                         handleEdit(software);
                                //                     }}
                                //                     className="edit_btn"
                                //                 >
                                //                     Edit
                                //                 </button>
                                //             </div>
                                //         </td>
                                //     </tr>
                                // )


                                <tr
                                    key={software._id}
                                    onClick={() => handleOpenDetails(software)}
                                    style={{ cursor: "pointer" }}
                                    className='text-[13px] '
                                >
                                    <td>{software.softwareName}</td>
                                    <td>{software.category}</td>


                                    {/* Show licenceType only for SUPER ADMIN */}
                                    {userRole === "SUPER ADMIN" ? (
                                        <>
                                            <td>
                                                {(Array.isArray(software.schoolLocation)
                                                    ? software.schoolLocation.join(', ')
                                                    : software.schoolLocation) || "N/A"}
                                            </td>
                                            <td>{software.licenceType}</td>
                                            <td>{software.status || "N/A"}</td>
                                            <td>{software.vendorName || "N/A"}</td>
                                        </>

                                    ) : (
                                        <>
                                            {/* <td
                                                style={{
                                                    width: "200px",
                                                    maxWidth: "200px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                {visibleRowId === software._id
                                                    ? software.portalId
                                                    : maskValue(software.portalId)}
                                            </td> */}
                                            {/* Portal ID */}
                                            <td
                                                style={{
                                                    width: "200px",
                                                    maxWidth: "250px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: "10px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            flex: 1,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {visibleRowId === software._id
                                                            ? software.portalId
                                                            : maskValue(software.portalId)}
                                                    </span>

                                                    {
                                                        visibleRowId === software._id ? <>
                                                            <span
                                                                style={{
                                                                    cursor: "pointer",
                                                                    flexShrink: 0,
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigator.clipboard.writeText(software.portalId);
                                                                }}
                                                                title="Copy Login ID"
                                                            >
                                                                <IoMdCopy size={18} />
                                                            </span>
                                                        </> : null
                                                    }
                                                </div>
                                            </td>

                                            {/* <td
                                                style={{
                                                    width: "200px",
                                                    maxWidth: "200px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }}
                                            >
                                                {visibleRowId === software._id
                                                    ? software.portalPassword
                                                    : maskValue(software.portalPassword)}
                                            </td> */}

                                            {/* Password */}

                                            <td
                                                style={{
                                                    width: "200px",
                                                    maxWidth: "250px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: "10px",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            flex: 1,
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {visibleRowId === software._id
                                                            ? software.portalPassword
                                                            : maskValue(software.portalPassword)}
                                                    </span>

                                                    {
                                                        visibleRowId === software._id ? <>
                                                            <span
                                                                style={{
                                                                    cursor: "pointer",
                                                                    flexShrink: 0,
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigator.clipboard.writeText(software.portalPassword);
                                                                }}
                                                                title="Copy Password"
                                                            >
                                                                <IoMdCopy size={18} />
                                                            </span>
                                                        </> : null
                                                    }
                                                </div>
                                            </td>
                                        </>
                                    )}


                                    <td>{software.ownerName || "N/A"}</td>

                                    <td>
                                        <div className="flex gap-4">
                                            {/* Common: Open Link */}
                                            <a
                                                href={software.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <GoLinkExternal color='blue' size={18} />
                                            </a>

                                            {/* Eye toggle only for non SUPER ADMIN */}
                                            {userRole !== "SUPER ADMIN" && (
                                                <span
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setVisibleRowId(
                                                            visibleRowId === software._id ? null : software._id
                                                        );
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {visibleRowId === software._id ? <IoEyeOff size={18} /> : <IoEye  size={18}/>}
                                                </span>
                                            )}

                                            {/* EDIT: SUPER ADMIN + ADMIN */}
                                            {(userRole === "SUPER ADMIN" || userRole === "ADMIN") && (
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleEdit(software);
                                                    }}
                                                    className="edit_btn"
                                                >
                                                    Edit
                                                </button>
                                            )}

                                            {/* DELETE: ONLY SUPER ADMIN */}
                                            {userRole === "SUPER ADMIN" && (
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDelete(software._id);
                                                    }}
                                                    className="delete_btn text-red-500 font-bold"
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>


                            ))}

                            {filteredSoftware.length === 0 && (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        {searchTerm ? "No software matched your search." : "No software details found."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {showAddSoftware && (
                    <AllSoftwareModal
                        onClose={handleCloseModal}
                        onSubmit={handleSubmitSoftware}
                        initialData={editingSoftware}
                        userRole={userRole}
                        userLocation={userLocation}
                    />
                )}

                {showSoftwareDetails && selectedSoftware && (
                    <SoftwareDetailsModal
                        software={selectedSoftware}
                        onClose={handleCloseDetails}
                        userRole={userRole}
                    />
                )}
            </div>

        </div>
    )
}

const SoftwareDetailsModal = ({ software, onClose, userRole }) => {
    const [activeTab, setActiveTab] = useState("details");


    const showValue = (value) => {
        if (value === null || value === undefined || value === "") return "N/A";
        return value;
    };

    const showDate = (value) => {
        if (!value) return "N/A";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return "N/A";
        return date.toLocaleString();
    };

    const renderField = (label, value) => (
        <div className="form_group">
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">{label}</label>
            <div className="w-full border rounded p-2 bg-gray-50 text-sm text-gray-700">
                {showValue(value)}
            </div>
        </div>
    );

    const HistoryItem = ({ item, nextState }) => {
        const [showMore, setShowMore] = useState(false);
        const prevState = item.changeData || {};
        const afterState = nextState || {};

        // Calculate diffs
        const changedFields = [];
        const excludedKeys = ['history', '__v', '_id', 'createdAt', 'updatedAt'];

        Object.keys({ ...prevState, ...afterState }).forEach(key => {
            if (excludedKeys.includes(key)) return;

            const prevVal = prevState[key];
            const afterVal = afterState[key];

            const stringify = (val) => {
                if (val === null || val === undefined) return "";
                if (Array.isArray(val)) return val.sort().join(", ");
                if (typeof val === 'string' && val.includes('T') && !isNaN(Date.parse(val))) {
                    return new Date(val).toLocaleDateString();
                }
                return String(val);
            };

            if (stringify(prevVal) !== stringify(afterVal)) {
                changedFields.push({
                    key,
                    from: prevVal,
                    to: afterVal,
                    label: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
                });
            }
        });

        const formatVal = (val) => {
            if (val === null || val === undefined || val === "") return "N/A";
            if (Array.isArray(val)) return val.join(", ");
            if (typeof val === 'string' && val.includes('T') && !isNaN(Date.parse(val))) {
                return new Date(val).toLocaleDateString();
            }
            return String(val);
        };

        return (
            <div className="border-l-2 border-blue-500 pl-4 py-4 relative bg-white hover:bg-gray-50 transition-colors">
                <div className="absolute w-3 h-3 bg-blue-500 rounded-full -left-[7px] top-6 shadow-sm"></div>

                <div className="flex justify-between items-start mb-2">
                    <div>
                        <div className="flex items-center gap-2">
                            <p className="text-sm font-bold text-gray-800">Software Update Recorded</p>
                            {changedFields.length > 0 && (
                                <span className="bg-amber-100 text-amber-700 text-[10px] px-2 py-0.5 rounded-full font-bold uppercase">
                                    {changedFields.length} {changedFields.length === 1 ? 'Field' : 'Fields'} Modified
                                </span>
                            )}
                        </div>
                        <p className="text-xs text-gray-500">{showDate(item.updatedAt)}</p>
                    </div>
                    <button
                        onClick={() => setShowMore(!showMore)}
                        className="text-xs text-blue-600 hover:text-blue-800 font-bold flex items-center gap-1 bg-blue-50 px-3 py-1 rounded"
                    >
                        {showMore ? "Hide Details" : "Track Changes"}
                        <IoChevronForward className={`transition-transform ${showMore ? 'rotate-90' : ''}`} />
                    </button>
                </div>

                {changedFields.length > 0 ? (
                    <div className="flex flex-wrap gap-2 mb-2">
                        {changedFields.slice(0, 3).map(df => (
                            <span key={df.key} className="text-[10px] bg-gray-100 text-gray-600 px-2 py-0.5 rounded border border-gray-200">
                                {df.label}
                            </span>
                        ))}
                        {changedFields.length > 3 && <span className="text-[10px] text-gray-400">+{changedFields.length - 3} more</span>}
                    </div>
                ) : (
                    <p className="text-xs text-gray-400 italic mb-2">No significant data changes detected in this snapshot.</p>
                )}

                {showMore && (
                    <div className="mt-4 space-y-3 bg-gray-50 p-4 rounded-xl border border-gray-200 animate-in slide-in-from-top-2 duration-300">
                        <div className="grid grid-cols-1 gap-4">
                            {changedFields.map(df => (
                                <div key={df.key} className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 p-2 bg-white rounded border border-amber-100 shadow-sm">
                                    <div className="min-w-[140px]">
                                        <span className="text-xs font-bold text-gray-600 uppercase tracking-tighter">{df.label}</span>
                                    </div>
                                    <div className="flex items-center gap-2 flex-grow">
                                        <div className="flex-1 bg-red-50 p-1.5 rounded text-[11px] text-red-700 line-through truncate opacity-70">
                                            {formatVal(df.from)}
                                        </div>
                                        <IoChevronForward className="text-amber-500" />
                                        <div className="flex-1 bg-green-50 p-1.5 rounded text-[11px] text-green-700 font-bold truncate">
                                            {formatVal(df.to)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mt-4 pt-4 border-t border-gray-200">
                            <p className="text-[10px] font-bold text-gray-400 uppercase mb-2">Full Snapshot (Before Update)</p>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-1 opacity-60">
                                {Object.entries(prevState).map(([k, v]) => {
                                    if (excludedKeys.includes(k) || !v) return null;
                                    return (
                                        <div key={k} className="text-[9px] truncate">
                                            <span className="font-semibold text-gray-500 capitalize">{k.replace(/([A-Z])/g, ' $1')}: </span>
                                            <span className="text-gray-700">{formatVal(v)}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    const historyList = software.history || [];
    const states = [...historyList.map(h => h.changeData), software];

    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4">
            <div className="bg-white w-full max-w-4xl rounded-xl shadow-2xl overflow-hidden overflow-y-scroll flex flex-col max-h-[90vh]">
                <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
                    <div>
                        <h2 className="text-lg font-bold text-gray-800">Software Asset Management</h2>
                        <p className="text-xs text-gray-500">Inventory ID: {software._id}</p>
                    </div>
                    <IoClose size={24} className="cursor-pointer hover:text-red-500 transition-colors" onClick={onClose} />
                </div>

                {
                    userRole === "SUPER ADMIN" || userRole === "ADMIN" ? (
                        <div>
                            {/* Tab Header */}
                            <div className="flex px-6 border-b bg-white">
                                <button
                                    className={`py-3 px-6 text-sm font-bold transition-all border-b-2 flex items-center gap-2 ${activeTab === 'details' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                                    onClick={() => setActiveTab('details')}
                                >
                                    Current Specifications
                                </button>
                                <button
                                    className={`py-3 px-6 text-sm font-bold transition-all border-b-2 flex items-center gap-2 ${activeTab === 'history' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                                    onClick={() => setActiveTab('history')}
                                >
                                    History
                                    <span className="bg-gray-100 text-gray-600 text-[10px] px-2 py-0.5 rounded-full">{historyList.length}</span>
                                </button>
                            </div>

                            <div className="p-6 overflow-y-auto flex-grow custom-scrollbar bg-gray-50/30">
                                {activeTab === 'details' ? (
                                    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-10">
                                        <section>
                                            <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                                <div className="w-8 h-[1px] bg-blue-500"></div>
                                                I. Software Basic Details
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                                {renderField("Software Name", software.softwareName)}
                                                {renderField("Category", software.category)}
                                                {renderField("School Location", Array.isArray(software.schoolLocation) ? software.schoolLocation.join(', ') : software.schoolLocation)}
                                                <div className="md:col-span-1">
                                                    {renderField("Description", software.description)}
                                                </div>
                                                {renderField("Licence Type", software.licenceType)}
                                                {renderField("Status", software.status)}
                                                <div className="md:col-span-2">
                                                    {renderField("Software URL", software.url)}
                                                </div>
                                                {renderField("Software Logdin Id", software.portalId)}
                                                {renderField("Software Password", software.portalPassword)}
                                            </div>
                                        </section>

                                        <section>
                                            <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                                <div className="w-8 h-[1px] bg-blue-500"></div>
                                                II. Hosting & Access Details
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                                {renderField("Hosting Type", software.hostingType)}
                                                {renderField("Application URL", software.applicationUrl)}
                                                {renderField("Server IP", software.ipServer)}
                                                {renderField("Service Provider", software.serviceProvider)}
                                                {renderField("Login ID", software.loginId)}
                                                {renderField("Password", software.loginPassword)}
                                                {renderField("Handler Name", software.handlerName)}
                                            </div>
                                        </section>

                                        <section>
                                            <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                                <div className="w-8 h-[1px] bg-blue-500"></div>
                                                III. Licence & Billing
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                                {renderField("Start Date", showDate(software.licenceStartDate))}
                                                {renderField("Expiration Date", showDate(software.licenceExpiryDate))}
                                                {renderField("Billing Cycle", software.billingCycle)}
                                                {renderField("Auto Renewal", software.autoRenewal)}
                                                {renderField("Licence Cost", software.licenceCost)}
                                                {renderField("Invoice ID", software.invoiceId)}
                                            </div>
                                        </section>

                                        <section>
                                            <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                                <div className="w-8 h-[1px] bg-blue-500"></div>
                                                IV. Vendor Contact Details
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                                {renderField("Vendor Name", software.vendorName)}
                                                {renderField("Vendor Website", software.vendorWebsite)}
                                                {renderField("Support Email", software.supportEmail)}
                                                {renderField("Support Phone", software.supportPhone)}
                                                {renderField("Account Manager", software.accountManager)}
                                            </div>
                                        </section>

                                        <section>
                                            <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                                <div className="w-8 h-[1px] bg-blue-500"></div>
                                                V. Internal Ownership
                                            </h3>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                                {renderField(
                                                    "Business Function",
                                                    Array.isArray(software.businessFunction)
                                                        ? software.businessFunction.join(", ")
                                                        : software.businessFunction
                                                )}
                                                {renderField("Number of Users", software.numberOfUsers)}
                                                {renderField("Owner Name", software.ownerName)}
                                                {renderField(
                                                    "Owner Email",
                                                    Array.isArray(software.ownerEmail)
                                                        ? software.ownerEmail.join(", ")
                                                        : software.ownerEmail
                                                )}
                                            </div>
                                        </section>
                                    </div>
                                ) : (
                                    <div className="max-w-3xl mx-auto py-4">
                                        <div className="bg-blue-600 text-white p-6 rounded-2xl shadow-lg mb-10 flex justify-between items-center overflow-hidden relative">
                                            <div className="relative z-10">
                                                <h4 className="xl:text-base 2xl:text-xl font-bold mb-1">Audit Log & Traceability</h4>
                                                <p className="text-blue-100 text-xs max-w-md">
                                                    Detailed breakdown of modifications made to this software asset over its lifecycle.
                                                    Expand items to compare previous values with updated records.
                                                </p>
                                            </div>
                                            <div className="absolute -right-8 -bottom-8 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
                                        </div>

                                        {historyList.length === 0 ? (
                                            <div className="py-24 text-center bg-white rounded-2xl border-2 border-dashed border-gray-200">
                                                <div className="bg-gray-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                                    <IoSave className="text-gray-300" size={32} />
                                                </div>
                                                <h5 className="text-gray-800 font-bold mb-1">No modifications yet</h5>
                                                <p className="text-gray-400 text-sm">Initial version is active. Subsequent edits will appear here.</p>
                                            </div>
                                        ) : (
                                            <div className="space-y-4">
                                                {[...historyList].reverse().map((item, index) => {
                                                    const originalIndex = historyList.length - 1 - index;
                                                    return (
                                                        <HistoryItem
                                                            key={item._id || index}
                                                            item={item}
                                                            nextState={states[originalIndex + 1]}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm space-y-10">
                            <section>
                                <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                    <div className="w-8 h-[1px] bg-blue-500"></div>
                                    I. Software Basic Details
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    {renderField("Software Name", software.softwareName)}
                                    {renderField("Category", software.category)}
                                    {renderField("School Location", Array.isArray(software.schoolLocation) ? software.schoolLocation.join(', ') : software.schoolLocation)}
                                    {/* <div className="md:col-span-2">
                                        {renderField("Description", software.description)}
                                    </div> */}
                                    {/* {renderField("Licence Type", software.licenceType)} */}
                                    {/* {renderField("Status", software.status)} */}
                                    <div className="md:col-span-2">
                                        {renderField("Software URL", software.url)}
                                    </div>
                                    {renderField("Software Logdin Id", software.portalId)}
                                    {renderField("Software Password", software.portalPassword)}
                                    {renderField("Owner Name", software.ownerName)}

                                </div>
                            </section>

                            {/* <section>
                                <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                    <div className="w-8 h-[1px] bg-blue-500"></div>
                                    II. Hosting & Access Details
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    {renderField("Hosting Type", software.hostingType)}
                                    {renderField("Application URL", software.applicationUrl)}
                                    {renderField("Server IP", software.ipServer)}
                                    {renderField("Service Provider", software.serviceProvider)}
                                    {renderField("Login ID", software.loginId)}
                                    {renderField("Password", software.loginPassword)}
                                    {renderField("Handler Name", software.handlerName)}
                                </div>
                            </section> */}
                            {/* 
                            <section>
                                <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                    <div className="w-8 h-[1px] bg-blue-500"></div>
                                    III. Licence & Billing
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    {renderField("Start Date", showDate(software.licenceStartDate))}
                                    {renderField("Expiration Date", showDate(software.licenceExpiryDate))}
                                    {renderField("Billing Cycle", software.billingCycle)}
                                    {renderField("Auto Renewal", software.autoRenewal)}
                                    {renderField("Licence Cost", software.licenceCost)}
                                    {renderField("Invoice ID", software.invoiceId)}
                                </div>
                            </section> */}

                            {/* <section>
                                <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                    <div className="w-8 h-[1px] bg-blue-500"></div>
                                    IV. Vendor Contact Details
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    {renderField("Vendor Name", software.vendorName)}
                                    {renderField("Vendor Website", software.vendorWebsite)}
                                    {renderField("Support Email", software.supportEmail)}
                                    {renderField("Support Phone", software.supportPhone)}
                                    {renderField("Account Manager", software.accountManager)}
                                </div>
                            </section> */}

                            {/* <section>
                                <h3 className="text-xs font-black text-gray-400 mb-6 flex items-center gap-2 uppercase tracking-[0.2em]">
                                    <div className="w-8 h-[1px] bg-blue-500"></div>
                                    V. Internal Ownership
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                                    {renderField(
                                        "Business Function",
                                        Array.isArray(software.businessFunction)
                                            ? software.businessFunction.join(", ")
                                            : software.businessFunction
                                    )}
                                    {renderField("Number of Users", software.numberOfUsers)}
                                    {renderField("Owner Name", software.ownerName)}
                                    {renderField(
                                        "Owner Email",
                                        Array.isArray(software.ownerEmail)
                                            ? software.ownerEmail.join(", ")
                                            : software.ownerEmail
                                    )}
                                </div>
                            </section> */}
                        </div>
                    )
                }




                <div className="px-6 py-4 border-t bg-white flex justify-end">
                    <button type="button" onClick={onClose} className="px-8 py-2.5 bg-gray-900 border border-gray-900 rounded-lg text-sm font-bold text-white hover:bg-gray-800 shadow-md transition-all active:scale-95">
                        Finish Review
                    </button>
                </div>
            </div>
        </div>
    );
};



const AllSoftwareModal = ({ onClose, onSubmit, initialData, userRole, userLocation }) => {
    const [viewPassword, setViewPassword] = useState(false)

    const [step, setStep] = useState(1);

    const handleViewPassword = () => {
        setViewPassword(!viewPassword)
    }

    const totalSteps = 5;

    const [locationSearch, setLocationSearch] = useState("");

    const [formData, setFormData] = useState({
        // Step 1: Software Details
        softwareName: "",
        category: "",
        description: "",
        licenceType: "",
        status: "Active",
        url: "",
        portalId: "",
        portalPassword: "",
        schoolLocation: [],
        // Step 2: Hosting Details
        hostingType: "",
        applicationUrl: "",
        ipServer: "",
        serviceProvider: "",
        region: "",
        loginId: "",
        loginPassword: "",
        handlerName: "",
        handlerDesignation: "",
        handlerEmail: "",
        // Step 3: Licence Details
        licenceStartDate: "",
        licenceExpiryDate: "",
        billingCycle: "",
        autoRenewal: "No",
        licenceCost: "",
        invoiceId: "",
        // Step 4: Vendor Details
        vendorName: "",
        vendorWebsite: "",
        supportEmail: "",
        supportPhone: "",
        accountManager: "",
        contractId: "",
        slaDetails: "",
        pointOfContact: "",
        // Step 5: Ownership Details
        primaryUsage: "",
        businessFunction: [],
        numberOfUsers: "",
        ownerName: "",
        ownerDesignation: "",
        ownerEmail: [],
        ownerPhone: ""
    });



    useEffect(() => {
        if (initialData) {
            const formattedData = { ...initialData };
            // Format dates for input fields
            if (formattedData.licenceStartDate) formattedData.licenceStartDate = new Date(formattedData.licenceStartDate).toISOString().split('T')[0];
            if (formattedData.licenceExpiryDate) formattedData.licenceExpiryDate = new Date(formattedData.licenceExpiryDate).toISOString().split('T')[0];
            formattedData.schoolLocation = formattedData.schoolLocation || [];

            setFormData(prev => ({ ...prev, ...formattedData }));
        }
    }, [initialData]);



    const [masterOptions, setMasterOptions] = useState({
        categories: [],
        licenceTypes: [],
        statuses: [],
        hostingTypes: [],
        businessFunctions: [],
        schoolLocations: []
    });

    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const response = await axios.get(`${API}/masters`);
                const allMasters = response.data;
                setMasterOptions({
                    categories: allMasters.filter(m => m.type === "Category").map(m => m.value),
                    licenceTypes: allMasters.filter(m => m.type === "Licence Type").map(m => m.value),
                    statuses: allMasters.filter(m => m.type === "Status").map(m => m.value),
                    hostingTypes: allMasters.filter(m => m.type === "Hosting Type").map(m => m.value),
                    businessFunctions: allMasters.filter(m => m.type === "Business Function").map(m => m.value),
                    schoolLocations: allMasters.filter(m => m.type === "School Location").map(m => m.value)
                });
            } catch (error) {
                console.error("Error fetching master data:", error);
            }
        };
        fetchMasters();
    }, []);

    useEffect(() => {
        if (userRole !== "SUPER ADMIN" && userLocation) {
            setFormData(prev => ({
                ...prev,
                schoolLocation: [userLocation] // force single location
            }));
        }
    }, [userRole, userLocation]);



    const handleEmailChange = (e) => {
        const { value } = e.target;
        // Split by comma and trim whitespace
        const emailArray = value.split(',').map(email => email.trim());
        setFormData(prev => ({
            ...prev,
            ownerEmail: emailArray
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        let updatedFunctions = [...formData.businessFunction];
        if (checked) {
            updatedFunctions.push(value);
        } else {
            updatedFunctions = updatedFunctions.filter(f => f !== value);
        }
        setFormData(prev => ({
            ...prev,
            businessFunction: updatedFunctions
        }));
    };

    const nextStep = () => setStep(prev => Math.min(prev + 1, totalSteps));
    const prevStep = () => setStep(prev => Math.max(prev - 1, 1));

    const handleSubmit = (e) => {
        e.preventDefault();
        if (step < totalSteps) {
            nextStep();
        } else {
            onSubmit(formData);
        }
    };

    const renderStep = () => {
        switch (step) {
            case 1:
                return (
                    <div className="space-y-4">
                        <h3 className="font-semibold text-gray-700">Step 1: Software Basic Details</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="form_group">
                                <label>Software Name*</label>
                                <input type="text" name="softwareName" value={formData.softwareName} onChange={handleChange} required className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Category*</label>
                                <select name="category" value={formData.category} onChange={handleChange} required className="w-full border rounded p-2">
                                    <option value="">Select Category</option>
                                    {masterOptions.categories.map(c => <option key={c} value={c}>{c}</option>)}
                                </select>
                            </div>
                            <div className="form_group col-span-2">
                                <label>Description</label>
                                <textarea name="description" value={formData.description} onChange={handleChange} className="w-full border rounded p-2" rows="2" />
                            </div>
                            <div className="form_group">
                                <label>Licence Type*</label>
                                <select name="licenceType" value={formData.licenceType} onChange={handleChange} required className="w-full border rounded p-2">
                                    <option value="">Select Type</option>
                                    {masterOptions.licenceTypes.map(l => <option key={l} value={l}>{l}</option>)}
                                </select>
                            </div>
                            <div className="form_group">
                                <label>Status</label>
                                <select name="status" value={formData.status} onChange={handleChange} className="w-full border rounded p-2">
                                    {masterOptions.statuses.map(s => <option key={s} value={s}>{s}</option>)}
                                </select>
                            </div>
                            <div className="form_group col-span-2">
                                <label>School Location(s)*</label>
                                {/* <input
                                    type="text"
                                    placeholder="Search locations..."
                                    value={locationSearch}
                                    onChange={(e) => setLocationSearch(e.target.value)}
                                    className="w-full border rounded-md px-3 py-2 mb-2"
                                /> */}

                                {userRole === "SUPER ADMIN" && (
                                    <input
                                        type="text"
                                        placeholder="Search locations..."
                                        value={locationSearch}
                                        onChange={(e) => setLocationSearch(e.target.value)}
                                        className="w-full border rounded-md px-3 py-2 mb-2"
                                    />
                                )}
                                <div className="border rounded-md px-3 py-2 max-h-40 overflow-y-auto w-full space-y-2 bg-white">
                                    {
                                        userRole === "SUPER ADMIN" ? (
                                            <>
                                                {masterOptions.schoolLocations
                                                    .filter(loc => loc.toLowerCase().includes(locationSearch.toLowerCase()))
                                                    .map(sl => (
                                                        <label key={sl} className="flex items-center gap-2 text-sm cursor-pointer">
                                                            <input
                                                                type="checkbox"
                                                                value={sl}
                                                                checked={formData.schoolLocation?.includes(sl)}
                                                                onChange={(e) => {
                                                                    const current = formData.schoolLocation || [];
                                                                    if (e.target.checked) {
                                                                        setFormData({ ...formData, schoolLocation: [...current, sl] });
                                                                    } else {
                                                                        setFormData({ ...formData, schoolLocation: current.filter(loc => loc !== sl) });
                                                                    }
                                                                }}
                                                            />
                                                            {sl}
                                                        </label>
                                                    ))}

                                                {masterOptions.schoolLocations.filter(loc => loc.toLowerCase().includes(locationSearch.toLowerCase())).length === 0 &&
                                                    <span className="text-gray-400 text-sm">No locations found.</span>}
                                            </>
                                        ) : (
                                            // 👇 NON ADMIN VIEW
                                            <label className="flex items-center gap-2 text-sm">
                                                <input
                                                    type="checkbox"
                                                    checked={true}
                                                    disabled
                                                />
                                                {userLocation}
                                            </label>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="form_group col-span-2">
                                <label>Software URL</label>
                                <input type="url" name="url" value={formData.url} onChange={handleChange} placeholder="https://" className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group ">
                                <label>Software LoginId</label>
                                <input type="text" name="portalId" value={formData.portalId} onChange={handleChange} placeholder="LoginId" className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group ">
                                <label>Software password</label>
                                <input type="text" name="portalPassword" value={formData.portalPassword} onChange={handleChange} placeholder="Password" className="w-full border rounded p-2" />
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="space-y-4">
                        <h3 className="font-semibold text-gray-700">Step 2: Hosting & Access Details</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="form_group">
                                <label>Hosting Type</label>
                                <select name="hostingType" value={formData.hostingType} onChange={handleChange} className="w-full border rounded p-2">
                                    <option value="">Select Type</option>
                                    {masterOptions.hostingTypes.map(h => <option key={h} value={h}>{h}</option>)}
                                </select>
                            </div>
                            <div className="form_group">
                                <label>Application URL</label>
                                <input type="text" name="applicationUrl" value={formData.applicationUrl} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Server IP</label>
                                <input type="text" name="ipServer" value={formData.ipServer} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Service Provider</label>
                                <input type="text" name="serviceProvider" value={formData.serviceProvider} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Login ID</label>
                                <input type="text" name="loginId" value={formData.loginId} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group ">
                                <label>Password</label>
                                <input type={`${viewPassword ? "text" : "password"}`} name="loginPassword" value={formData.loginPassword} onChange={handleChange} className="w-full border rounded p-2" />
                                <span>{viewPassword && viewPassword === true ? <IoEye onClick={handleViewPassword} /> : <IoEyeOff onClick={handleViewPassword} />}</span>
                            </div>
                            <div className="form_group col-span-2">
                                <label>Handler Name</label>
                                <input type="text" name="handlerName" value={formData.handlerName} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="space-y-4">
                        <h3 className="font-semibold text-gray-700">Step 3: Licence & Billing</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="form_group">
                                <label>Start Date</label>
                                <input type="date" name="licenceStartDate" value={formData.licenceStartDate} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Expiry Date</label>
                                <input type="date" name="licenceExpiryDate" value={formData.licenceExpiryDate} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Billing Cycle</label>
                                <select name="billingCycle" value={formData.billingCycle} onChange={handleChange} className="w-full border rounded p-2">
                                    <option value="">Select Cycle</option>
                                    <option>Monthly</option>
                                    <option>Quarterly</option>
                                    <option>Annually</option>
                                    <option>One-time</option>
                                </select>
                            </div>
                            <div className="form_group">
                                <label>Auto Renewal</label>
                                <select name="autoRenewal" value={formData.autoRenewal} onChange={handleChange} className="w-full border rounded p-2">
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </div>
                            <div className="form_group">
                                <label>Licence Cost</label>
                                <input type="number" name="licenceCost" value={formData.licenceCost} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Invoice ID</label>
                                <input type="text" name="invoiceId" value={formData.invoiceId} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                        </div>
                    </div>
                );
            case 4:
                return (
                    <div className="space-y-4">
                        <h3 className="font-semibold text-gray-700">Step 4: Vendor Contact Details</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="form_group">
                                <label>Vendor Name</label>
                                <input type="text" name="vendorName" value={formData.vendorName} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Vendor Website</label>
                                <input type="url" name="vendorWebsite" value={formData.vendorWebsite} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Support Email</label>
                                <input type="email" name="supportEmail" value={formData.supportEmail} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Support Phone</label>
                                <input type="text" name="supportPhone" value={formData.supportPhone} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Account Manager</label>
                                <input type="text" name="accountManager" value={formData.accountManager} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                        </div>
                    </div>
                );
            case 5:
                return (
                    <div className="space-y-4">
                        <h3 className="font-semibold text-gray-700">Step 5: Internal Ownership</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="form_group col-span-2">
                                <label>Business Function</label>
                                <div className="grid grid-cols-3 gap-2">
                                    {masterOptions.businessFunctions.map(func => (
                                        <label key={func} className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                value={func}
                                                checked={formData.businessFunction.includes(func)}
                                                onChange={handleCheckboxChange}
                                            />
                                            {func}
                                        </label>
                                    ))}
                                </div>
                            </div>
                            <div className="form_group">
                                <label>Owner Name</label>
                                <input type="text" name="ownerName" value={formData.ownerName} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                            <div className="form_group">
                                <label>Owner Email (Comma separated)*</label>
                                <input
                                    type="text"
                                    name="ownerEmail"
                                    value={Array.isArray(formData.ownerEmail) ? formData.ownerEmail.join(", ") : formData.ownerEmail}
                                    onChange={handleEmailChange}
                                    required
                                    placeholder="email1@example.com, email2@example.com"
                                    className="w-full border rounded p-2"
                                />
                            </div>

                            <div className="form_group">
                                <label>Number of Users</label>
                                <input type="number" name="numberOfUsers" value={formData.numberOfUsers} onChange={handleChange} className="w-full border rounded p-2" />
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
            <div className="bg-white w-[600px] rounded-xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
                {/* Header */}
                <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
                    <div>
                        <h2 className="text-lg font-bold text-gray-800">
                            {initialData ? "Edit Software" : "Register New Software"}
                        </h2>
                        <p className="text-xs text-gray-500">Step {step} of {totalSteps}</p>
                    </div>
                    <IoClose size={24} className="cursor-pointer hover:text-red-500" onClick={onClose} />
                </div>

                {/* Progress Bar */}
                <div className="w-full h-1 bg-gray-200">
                    <div
                        className="h-full bg-blue-600 transition-all duration-300"
                        style={{ width: `${(step / totalSteps) * 100}%` }}
                    />
                </div>

                {/* Body */}
                <form onSubmit={handleSubmit} className="p-6 overflow-y-auto flex-grow">
                    {renderStep()}
                </form>

                {/* Footer */}
                <div className="px-6 py-4 border-t bg-gray-50 flex justify-between items-center">
                    <button
                        type="button"
                        onClick={prevStep}
                        disabled={step === 1}
                        className={`flex items-center gap-1 px-4 py-2 border rounded font-medium ${step === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-gray-100'}`}
                    >
                        <IoChevronBack /> Previous
                    </button>

                    <div className="flex gap-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 text-gray-500 hover:underline">Cancel</button>
                        <button
                            onClick={handleSubmit}
                            type="button"
                            className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700 shadow-lg"
                        >
                            {step === totalSteps ? (
                                <><IoSave /> {initialData ? "Update" : "Save Details"}</>
                            ) : (
                                <>Next <IoChevronForward /></>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllSoftware
